import { NameBuilderConfiguration, ReprocessingTaskOptionsOverride } from '../../models';
import { IWidgetConfiguration } from '../models';

export class SpotValuesWidgetConfiguration implements IWidgetConfiguration {
    group: string;
    hasLastValue: boolean;
    hasTagName: boolean;
    hasTimeStamp: boolean;
    hasUserComment: boolean;
    hasValue: boolean;
    is2DTable?: boolean;
    isBound?: boolean;
    nameConfiguration: NameBuilderConfiguration;
    referenceGroup?: string;
    taskOptionsOverride?: ReprocessingTaskOptionsOverride;

    constructor() {
        this.hasLastValue = true;
        this.hasTagName = true;
        this.hasTimeStamp = true;
        this.hasUserComment = true;
        this.hasValue = true;
        this.nameConfiguration = new NameBuilderConfiguration();
        this.taskOptionsOverride = { includeDependent: false };
    }
}
